import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AccessRule } from '../../../../../common/model/users/accessRule';
import { RoleViewModel } from '../../../../../common/model/users/role/roleViewModel';
import { ActionType } from '../../../../actions/model';

export interface ActiveRoleAccessState {
    role: RoleViewModel | null;
    accessRules: AccessRule[];
}

const initialState: ActiveRoleAccessState = {
    role: null,
    accessRules: [],
};

export const activeRoleAccessSlice = createSlice({
    name: '@@vp/users/roles/active',
    initialState,
    reducers: {
        setActiveRole(state, action: PayloadAction<ActiveRoleAccessState['role']>): void {
            state.role = action.payload;
        },
        setAccessRules(state, action: PayloadAction<AccessRule[]>): void {
            state.accessRules = action.payload;
        },
    },
    extraReducers: {
        [ActionType.LOGOUT]: (): ActiveRoleAccessState => initialState,
    }
});


export const {
    setActiveRole,
    setAccessRules
} = activeRoleAccessSlice.actions;
